export default __webpack_public_path__ + "images/Q6.20a1a0c.png";